"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: offer/offer-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Foffer%2Foffer-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferServiceClient = exports.GetPartnerTokenResponse = exports.GetPartnerTokenRequest = exports.FanimalTokenRequest = exports.UnenrollFromOfferResponse = exports.UnenrollFromOfferRequest = exports.EnrollToOfferResponse = exports.EnrollToOfferRequest = exports.GetAllOffersResponse = exports.GetAllOffersRequest = exports.RedeemOfferCodeResponse = exports.RedeemOfferCodeRequest = exports.OfferRedemption = exports.ReferralRedemption = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const offer_details_1 = require("./offer-details");
const protobufPackage = 'com.step.offer.proto';
function createBaseReferralRedemption() {
    return { rewarded: false };
}
exports.ReferralRedemption = {
    fromJSON(object) {
        const message = {
            rewarded: isSet(object.rewarded) ? globalThis.Boolean(object.rewarded) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewarded !== false) {
            obj.rewarded = message.rewarded;
        }
        return obj;
    },
    create(base) {
        return exports.ReferralRedemption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralRedemption();
        message.rewarded = object.rewarded ?? false;
        return message;
    },
};
function createBaseOfferRedemption() {
    return { offer: offer_details_1.OfferDetails.fromPartial({}) };
}
exports.OfferRedemption = {
    fromJSON(object) {
        const message = {
            offer: isSet(object.offer)
                ? offer_details_1.OfferDetails.fromJSON(object.offer)
                : offer_details_1.OfferDetails.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offer !== undefined) {
            obj.offer = offer_details_1.OfferDetails.toJSON(message.offer);
        }
        return obj;
    },
    create(base) {
        return exports.OfferRedemption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferRedemption();
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_details_1.OfferDetails.fromPartial(object.offer)
            : offer_details_1.OfferDetails.fromPartial({});
        return message;
    },
};
function createBaseRedeemOfferCodeRequest() {
    return { code: '' };
}
exports.RedeemOfferCodeRequest = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        return obj;
    },
    create(base) {
        return exports.RedeemOfferCodeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemOfferCodeRequest();
        message.code = object.code ?? '';
        return message;
    },
};
function createBaseRedeemOfferCodeResponse() {
    return { offer: undefined, referral: undefined };
}
exports.RedeemOfferCodeResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.offer)) {
            message.offer = exports.OfferRedemption.fromJSON(object.offer);
        }
        if (isSet(object.referral)) {
            message.referral = exports.ReferralRedemption.fromJSON(object.referral);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offer !== undefined) {
            obj.offer = exports.OfferRedemption.toJSON(message.offer);
        }
        if (message.referral !== undefined) {
            obj.referral = exports.ReferralRedemption.toJSON(message.referral);
        }
        return obj;
    },
    create(base) {
        return exports.RedeemOfferCodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemOfferCodeResponse();
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? exports.OfferRedemption.fromPartial(object.offer)
            : undefined;
        message.referral = (object.referral !== undefined && object.referral !== null)
            ? exports.ReferralRedemption.fromPartial(object.referral)
            : undefined;
        return message;
    },
};
function createBaseGetAllOffersRequest() {
    return {};
}
exports.GetAllOffersRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetAllOffersRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetAllOffersRequest();
        return message;
    },
};
function createBaseGetAllOffersResponse() {
    return { offers: [] };
}
exports.GetAllOffersResponse = {
    fromJSON(object) {
        const message = {
            offers: globalThis.Array.isArray(object?.offers)
                ? object.offers.map((e) => offer_details_1.OfferForUser.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offers?.length) {
            obj.offers = message.offers.map((e) => offer_details_1.OfferForUser.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAllOffersResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAllOffersResponse();
        message.offers = object.offers?.map((e) => offer_details_1.OfferForUser.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEnrollToOfferRequest() {
    return { id: '' };
}
exports.EnrollToOfferRequest = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.EnrollToOfferRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollToOfferRequest();
        message.id = object.id ?? '';
        return message;
    },
};
function createBaseEnrollToOfferResponse() {
    return { offer: offer_details_1.OfferDetails.fromPartial({}) };
}
exports.EnrollToOfferResponse = {
    fromJSON(object) {
        const message = {
            offer: isSet(object.offer)
                ? offer_details_1.OfferDetails.fromJSON(object.offer)
                : offer_details_1.OfferDetails.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offer !== undefined) {
            obj.offer = offer_details_1.OfferDetails.toJSON(message.offer);
        }
        return obj;
    },
    create(base) {
        return exports.EnrollToOfferResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollToOfferResponse();
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_details_1.OfferDetails.fromPartial(object.offer)
            : offer_details_1.OfferDetails.fromPartial({});
        return message;
    },
};
function createBaseUnenrollFromOfferRequest() {
    return { id: '' };
}
exports.UnenrollFromOfferRequest = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.UnenrollFromOfferRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnenrollFromOfferRequest();
        message.id = object.id ?? '';
        return message;
    },
};
function createBaseUnenrollFromOfferResponse() {
    return { offer: offer_details_1.OfferDetails.fromPartial({}) };
}
exports.UnenrollFromOfferResponse = {
    fromJSON(object) {
        const message = {
            offer: isSet(object.offer)
                ? offer_details_1.OfferDetails.fromJSON(object.offer)
                : offer_details_1.OfferDetails.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offer !== undefined) {
            obj.offer = offer_details_1.OfferDetails.toJSON(message.offer);
        }
        return obj;
    },
    create(base) {
        return exports.UnenrollFromOfferResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnenrollFromOfferResponse();
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_details_1.OfferDetails.fromPartial(object.offer)
            : offer_details_1.OfferDetails.fromPartial({});
        return message;
    },
};
function createBaseFanimalTokenRequest() {
    return {};
}
exports.FanimalTokenRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.FanimalTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFanimalTokenRequest();
        return message;
    },
};
function createBaseGetPartnerTokenRequest() {
    return { fanimal: undefined };
}
exports.GetPartnerTokenRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.fanimal)) {
            message.fanimal = exports.FanimalTokenRequest.fromJSON(object.fanimal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fanimal !== undefined) {
            obj.fanimal = exports.FanimalTokenRequest.toJSON(message.fanimal);
        }
        return obj;
    },
    create(base) {
        return exports.GetPartnerTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPartnerTokenRequest();
        message.fanimal = (object.fanimal !== undefined && object.fanimal !== null)
            ? exports.FanimalTokenRequest.fromPartial(object.fanimal)
            : undefined;
        return message;
    },
};
function createBaseGetPartnerTokenResponse() {
    return { token: '' };
}
exports.GetPartnerTokenResponse = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? globalThis.String(object.token) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== '') {
            obj.token = message.token;
        }
        return obj;
    },
    create(base) {
        return exports.GetPartnerTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPartnerTokenResponse();
        message.token = object.token ?? '';
        return message;
    },
};
/**
 * OfferService API.
 */
class OfferServiceClient {
    rpc;
    name = 'com.step.offer.proto.OfferService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/referral';
    methods = [{
            name: 'EnrollToOffer',
            requestType: exports.EnrollToOfferRequest,
            responseType: exports.EnrollToOfferResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UnenrollFromOffer',
            requestType: exports.UnenrollFromOfferRequest,
            responseType: exports.UnenrollFromOfferResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RedeemOfferCode',
            requestType: exports.RedeemOfferCodeRequest,
            responseType: exports.RedeemOfferCodeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAllOffers',
            requestType: exports.GetAllOffersRequest,
            responseType: exports.GetAllOffersResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetPartnerToken',
            requestType: exports.GetPartnerTokenRequest,
            responseType: exports.GetPartnerTokenResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Enrolls user to offer.
     */
    enrollToOffer(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Un-enrolls user from offer.
     */
    unenrollFromOffer(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Redeems an offer (or a referral) code
     */
    redeemOfferCode(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns list of all offers that user is eligible for
     */
    getAllOffers(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a partner token. Used for perks.
     */
    getPartnerToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.OfferServiceClient = OfferServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=offer-service.js.map